module.exports = __webpack_public_path__ + "static/media/joystick.82dabe7c.svg";